import { router } from '@/libs/Router';
import { user } from '@/stores';


export default (to, from, next) => {
	const userId = user.pull('id');
	//console.log(userId, to.path, from);
	if (userId) {
		if (to.path === '/auth') {
			router.go('/');
		}
		else {
			next();
		}
	}
	else {
		if (to.path === '/auth' || to.path === '/register') {
			next();
		}
		else {
			router.go('/auth', { onLogin: to.urn });
		}
	}
};
